











import {Component, Vue} from 'vue-property-decorator';
import G3wButton from '@/components/default/g3wButton.vue';
import CountryFlag from 'vue-country-flag';
import Menu from '@/components/default/Menu.vue';
import HeaderButtons from './HeaderButtons.vue';
import {mapGetters} from "vuex";

@Component({
    components: {Menu, HeaderButtons, G3wButton, CountryFlag},
    computed: {
        ...mapGetters({
            'showAdmin': 'settings/showAdminButton'
        })
    }
})
export default class MobileMenu extends Vue {
    private toggleMenu() {
        this.$store.dispatch('menu/toggleVisibility');
    }
}
